/** @jsx withSlots */
import * as React from 'react';
import { withSlots, createComponent, getSlots } from '../../../Foundation';
import { styles } from './StackItem.styles';
var view = function (props) {
    var children = props.children;
    if (React.Children.count(children) < 1) {
        return null;
    }
    var Slots = getSlots(props, {
        root: 'div'
    });
    return withSlots(Slots.root, null, children);
};
export var StackItem = createComponent({
    displayName: 'StackItem',
    styles: styles,
    view: view
});
export default StackItem;
//# sourceMappingURL=StackItem.js.map